import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const CurrentUsers = styled.div`
    margin-top: 2rem;
    padding: 0.5rem;
`;

export const UsersGridContainer = styled.div`
    font-size: 1.4rem;
    width: 100%;
`;

const UsersColumn = styled.div<{ $color: string }>`
    max-width: auto;
    display: grid;
    grid-template-columns: 0.8fr 0.8fr 1.5fr 0.6fr;
    grid-template-areas: 'first-name last-name email actions';
    color: ${({ $color }) => $color};
`;

export const UsersHeader = styled(UsersColumn)`
    align-items: start;
    font-weight: 500;
    font-size: 1.5rem;
    padding-bottom: 1.5rem;
`;

export const UsersInfoList = styled.div<{ $maxHeight: string }>`
    overflow-y: auto;
    max-height: ${({ $maxHeight }) => $maxHeight};
`;

export const UsersListItem = styled(UsersColumn)`
    align-items: center;
`;

export const FirstNameColumn = styled.span`
    width: 90%;
    grid-area: first-name;
`;

export const LastNameColumn = styled.span`
    width: 90%;
    grid-area: last-name;
`;

export const EmailColumn = styled.span`
    grid-area: email;
`;

export const ActionsColumn = styled.span`
    justify-self: end;
    grid-area: actions;
    flex-direction: row;
    display: flex;
    align-items: center;
`;

export const SubscribersGridContainer = styled(UsersGridContainer)`
    width: 70rem;
    padding: 2rem;
    background: ${tokens.background.paperElevation8};
`;

export const SubscribersList = styled(UsersInfoList)`
    max-width: 70rem;
`;
